import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { CocaColaTheme } from './colors';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <StyledThemeProvider theme={CocaColaTheme}>
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;